import React from "react";
import PropTypes from "prop-types";

import { Switch } from "@mui/material";
import { withStyles } from "tss-react/mui";

const style = {};

//Paar kleine aanpassingen in de standard switch om hem makkelijker te implementeren in Jamezz admin
//Als de checkbox niet gezet is wordt er een hidden value bij gezet
//Dit om dat je dan makkelijker in laravel mass assigment op 0 / false te kunnen zetten

function CustomSwitchStringVal({ ...props }) {
  const { classes } = props;

  //De Switch component wilt als checked value een boolean hebben.
  //maar 99% van de keer komt er uit de database 0/1 terug
  // const convertChecked = (checked) => {
  //   if (typeof checked === "number") {
  //     return checked === 1;
  //   }

  //   if (typeof checked === "string") {
  //     return checked === "1";
  //   }

  //   return checked;
  // };

  return [
    props.checked ? null : <input key={"input"} name={props.name} type={"hidden"} value={0} />,
    <Switch
      checked={props.checked}
      classes={{
        switchBase: classes.switchBase,
        checked: classes.switchChecked,
        thumb: classes.switchIcon,
        track: classes.switchBar,
      }}
      disabled={props.disabled}
      id={props.name}
      inputProps={{
        name: props.name,
        disabled: props.disabled,
      }}
      key={"switch"}
      onChange={props.onChange}
      value={props.value}
    />,
  ];
}

CustomSwitchStringVal.defaultProps = {
  disabled: false,
  checked: false,
};

CustomSwitchStringVal.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default withStyles(CustomSwitchStringVal, style);
